import gql from 'graphql-tag';

/**
 * GraphQL query to fetch lexicon information
 * Returns lexicon details including rights and attribution
 *
 * The query fetches:
 * - title: The lexicon title
 * - uri: The lexicon URI
 * - label: The lexicon label
 * - rights: Rights information
 * - attribution: Attribution information
 * - source: Source information
 */
export default gql`
  query LexiconDetail($uri: String!) {
    lexicons(filters: { uri: { exact: $uri } }, pagination: { limit: 1, offset: 0 }) {
      title
      uri
      label
      rights
      attribution
      source
    }
  }
`;
